import { render } from "./ZenModal.vue?vue&type=template&id=73d0274c&scoped=true&ts=true"
import script from "./ZenModal.vue?vue&type=script&lang=ts"
export * from "./ZenModal.vue?vue&type=script&lang=ts"

import "./ZenModal.vue?vue&type=style&index=0&id=73d0274c&scoped=true&lang=css"

import exportComponent from "/Users/jiunjyechin/PhpstormProjects/Zenship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d0274c"]])

export default __exports__